export * from './cookie-consent-modal/cookie-consent-modal.component';

import { CookieConsentModalComponent } from './cookie-consent-modal/cookie-consent-modal.component';

export const ALL_COOKIE_CONSENT_MODAL_COMPONENT = [
    CookieConsentModalComponent,   
]